import styled from 'styled-components'
import ContentCard from '../../atoms/ContentCard'

export const Title = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  font-weight: 500;
  position: sticky;
  top: 0;
`

export const RightComponentCard = styled.div`
  box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.1);
  height: fit-content;
`

// The card used to clip whatever did not fit, which left parts of the page
// unreachable on a narrow window
export const Card = styled(ContentCard)`
  overflow: auto;
`

export const ComponentContainer = styled.div<{ stackBelow: number }>`
  display: flex;
  height: 100%;
  @media (max-width: ${({ stackBelow }) => stackBelow}px) {
    flex-direction: column-reverse;
  }
`
